import { ApiClient } from '../ApiClient';
import { billingAndShippingAddress } from './billingAndShippingAddress';
import { checkoutConfirmation } from './checkoutConfirmation';
import { checkoutSteps } from './checkoutSteps';
const apiClient = new ApiClient('/api/checkout');
export function Checkout(model) {
    return {
        ...model,
        ...checkoutSteps,
        ...billingAndShippingAddress,
        ...checkoutConfirmation,
        freightCost: '',
        paymentMethod: 'Netseasy',
        errorMessage: '',
        acceptTerms: false,
        sectionError: 999,
        isValid: true,
        isLoading: false,
        shippingMethods: [],
        shippingMethod: '',
        currentTimeTable: { name: '', timeTable: [] },
        deliverySummary: '',
        selectedShippingGroup: undefined,
        selectedShippingMethodId: 0,
        selectedShippingMethod: undefined,
        init($watch) {
            this.billingAndShippingAddressInit(this.user, model.countries);
            this.checkoutStepsInit($watch, (step, previous) => this.onStep(step, previous));
            this.checkoutConfirmationinit();
            $watch('shippingMethod', (value) => {
                var _a, _b;
                this.selectedShippingGroup = this.shippingMethods.find(s => s.name === value);
                this.selectedShippingMethodId = (_b = (_a = this.selectedShippingGroup) === null || _a === void 0 ? void 0 : _a.entries[0].id) !== null && _b !== void 0 ? _b : 0;
            });
            $watch('selectedShippingMethodId', (value) => {
                var _a;
                this.selectedShippingMethod = (_a = this.selectedShippingGroup) === null || _a === void 0 ? void 0 : _a.entries.find(e => e.id === parseInt(value));
            });
        },
        async submit() {
            var _a;
            this.isLoading = true;
            const data = {
                shippingMethodId: this.selectedShippingMethodId,
                paymentMethod: this.paymentMethod,
                comment: this.comment,
            };
            try {
                const res = await apiClient.post('/place-order', data);
                window.location.replace(res.redirectUrl);
            }
            catch (error) {
                this.errorMessage = (error === null || error === void 0 ? void 0 : error.status) === 400
                    ? error.data[0].errorMessage
                    : (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message;
            }
            finally {
                this.isLoading = false;
            }
            ;
        },
        async onStep(step, previous) {
            if (previous == 1) {
                // todo: this should only be done when we implement temporary delivery address for this order only
                // await this.updateShipmentAddress(deliveryAddress);
            }
            if (step == 2 && previous == 1) {
                const shippingMethods = await apiClient.get(`/shipping`);
                this.shippingMethods = shippingMethods;
                this.shippingMethod = this.shippingMethods[0].name;
            }
            if (step == 3 && previous == 2) {
                await this.updateShipment(this.selectedShippingMethodId);
            }
        }
    };
}
